<template>
    <div>

    </div>
</template>

<script>
   
export default {
    name: 'Article',

    data: () => ({
        name: null,
    }),
    created() {
        this.name = this.$route.params.name;
        this.LoadArticle();
    },
    methods: {
        LoadArticle() {
            
        },
        
    },
}
</script>

<style lang="scss" scoped>

</style>